module.exports = __webpack_public_path__ + "static/media/COPING_MIXED.d10250be.md";